import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import {
    Button,
    Card,
    CardContent, Container,
    Dialog,
    DialogActions,
    DialogContent, DialogContentText,
    DialogTitle,
    Fade, FormControl,
    IconButton,
    Stack,
    Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow,
    TextField,
    Typography,
    Divider
} from "@mui/material";
import React, { useCallback, useEffect, useState, useMemo } from "react";
import BackdropLoader from '../../components/BackdropLoader.jsx';
import SearchField from "../../components/SearchField.jsx";
import globalStyles from '../../components/styles/css/GlobalStyles.module.css';
import { api } from '../../utils/apiFunctions';
import { useStoreState } from "pullstate";
import { AppStore } from "../../stores/AppStore.js";
import useDebouncedValue from '../../utils/useDebouncedValue.js';
import { getTitles } from '../../utils/getData.js';

const Titles = () => {
    const openAlert = useStoreState(AppStore, s => s.snackbar.openAlert);
	const loading = useStoreState(AppStore, s => s.loading)
    const googleToken = useStoreState(AppStore, s => s.googleToken);
    const titles = useStoreState(AppStore, s => s.titles);
    const searchText = useStoreState(AppStore, s => s.searchText)
    const debouncedSearchText = useDebouncedValue(searchText, 100);
    const [title, setTitle] = useState([])
    const [titleForms, setTitleForms] = useState(false)
    const [editingRowId, setEditingRowId] = useState(null);
    const [tempTextField, setTempTextField] = useState('')
    const [iconVisible, setIconsVisible] = useState(false)
    const [openDeleteTitle, setOpenDeleteTitle] = useState(false)
    const [titleToDelete, setTitleToDelete] = useState({
        title: '',
        id: ''
    })

    const handleCloseDialog = () => {
        setOpenDeleteTitle(false)
    }

    useEffect(() => {
        if (!titles) getTitles();
    }, [titles]);

    const titlesFiltered = useMemo(() => {
        const q = debouncedSearchText.toLowerCase();
        return (titles ?? []).filter(title => title.title.toLowerCase().includes(q));
    }, [titles, debouncedSearchText]);

    const saveNewTitle = async (newTitle) => {

		AppStore.update((s) => {s.loading = true})
        try {
            api.post(`/titles/`, { title: newTitle }, {
                headers: {
                    Authorization: `Bearer ${googleToken}`
                }
            }).then(async res => {
                if (res.status === 200) {
                    openAlert('Title created sucessful', 'success')
					AppStore.update((s) => {s.loading = false})
                    getTitles()
                }
            })
        } catch (error) {
            openAlert(error.message, 'error')
            console.log(error)
        }

        setEditingRowId(null)
    };

    const deleteTitle = useCallback(async () => {
        setOpenDeleteTitle(false)
		AppStore.update((s) => {s.loading = true})
        const id = titleToDelete.id

        try {
            api.delete(`/titles/${id}`, {
                headers: {
                    Authorization: `Bearer ${googleToken}`
                }
            }).then(async res => {
                openAlert(res.data.message, res.status === 200 ? 'success' : 'error')
                AppStore.update((s) => {s.loading = false})
                getTitles()
            })
        } catch (error) {
            openAlert(error.message, 'error')
            console.log(error)
        }

        setEditingRowId(null);
    }, [titleToDelete.id, googleToken, getTitles])

    const updateTitle = async (id, newTitle) => {
		AppStore.update((s) => {s.loading = true})
        try {
            const res = await api.put(`/titles/${id}`, { title: newTitle },
                {
                    headers: {
                        Authorization: `Bearer ${googleToken}`
                    }
                }
            )

            if (res.status === 200) {
                openAlert('Title updated successful', 'success')
                AppStore.update(s => { s.loading = false })
                setTitle(newTitle)
                getTitles()
            }
        } catch (error) {
            AppStore.update(s => { s.loading = false })
            if ( error.status === 403 ) {
                setTitle(newTitle)
                getTitles()
            }
            openAlert(error?.response?.data?.message || error.message, 'error')
            console.error(error)
        }

        setEditingRowId(null);
    };

    return (
        <Container maxWidth="xl" sx={{ mt: 10 }}>
            <Card className={globalStyles.card}>
            <Typography sx={{ paddingTop: '20px' }} variant='h5' align='center'>Titles</Typography>
        		<BackdropLoader openBackdrop={loading} />
                <CardContent sx={{paddingTop: 0}}>
                    <Stack mb={1} direction="row" justifyContent='space-between' >
                        <SearchField />
                        <Button
                            onClick={() => {
                                setEditingRowId(null)
                                setTitleForms(!titleForms)
                            }}
                            variant="text"
                            startIcon={<AddIcon />}
                        >Add New</Button>
                    </Stack>
                    {titleForms && (
                        <Fade in={titleForms} timeout={200}>
                            <Card sx={{ boxShadow: 3, marginBottom: 2 }}>
                                <CardContent>
                                    <FormControl fullWidth sx={{ m: 0 }} >
                                        <Stack direction="row" spacing={1}>
                                            <TextField
                                                size="small"
                                                sx={{ width: '30%' }}
                                                id="outlined-basic"
                                                label="Title Name"
                                                variant="outlined"
                                                onChange={(e) => setTitle(e.target.value)}
                                            />
                                            <Button
                                                onClick={() => {
                                                    setTitleForms(false)
                                                    saveNewTitle(title)
                                                }}
                                                variant="outlined"
                                                sx={{ width: '10%' }}
                                            >Save</Button>
                                        </Stack>
                                    </FormControl>
                                </CardContent>
                            </Card>
                        </Fade>
                    )}
                    <TableContainer sx={{ boxShadow: 3 }} className={globalStyles.tableContainer}>
                        
            
                        <Table stickyHeader className={globalStyles.tableStyles}>
                            <TableBody>
                                {titlesFiltered.map(title => (
                                    <TableRow
                                        hover
                                        sx={{ height: 70 }}
                                        className={globalStyles.cursor_pointer}
                                        key={title.id}
                                    >
                                        <TableCell>
                                            {editingRowId === title.id ? (
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    value={tempTextField}
                                                    onChange={(e) => setTempTextField(e.target.value)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            updateTitle(title.id, tempTextField);
                                                        }
                                                    }}
                                                    autoFocus
                                                />
                                            ) : (
                                                title.title
                                            )}
                                        </TableCell>
                                        <TableCell sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                            {(editingRowId !== title.id) && (
                                                <Stack direction='row' spacing={1}>
                                                    <IconButton
                                                        onClick={() => {
                                                            setIconsVisible('hidden')
                                                            setTitleForms(false)
                                                            setEditingRowId(title.id);
                                                            setTempTextField(title.title);
                                                        }}
                                                        size="small" >
                                                        <EditIcon />
                                                    </IconButton>
                                                    <IconButton
                                                        onClick={() => {
                                                            setOpenDeleteTitle(true)
                                                            setTitleToDelete({
                                                                title: title.title,
                                                                id: title.id
                                                            })
                                                        }}
                                                        size="small">
                                                        <DeleteIcon
                                                        />
                                                    </IconButton>
                                                </Stack>
                                            )}
                                            {editingRowId === title.id && (
                                                <Stack direction='row'>
                                                    <IconButton onClick={() => {
                                                        updateTitle(title.id, tempTextField)
                                                    }}
                                                        size="small">
                                                        <SaveIcon />
                                                    </IconButton>
                                                    <IconButton onClick={() => setEditingRowId(null)}>
                                                        <CloseIcon />
                                                    </IconButton>
                                                </Stack>
                                            )}
                                        </TableCell>
                                    </TableRow>

                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </CardContent>
            </Card>
            <Dialog
                open={openDeleteTitle}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"WARNING!"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        You are about to delete {titleToDelete.title}.
                        All employees with this title will have an empty field.
                        Are you sure you want to proceed?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog}>Cancel</Button>
                    <Button onClick={deleteTitle} >Confirm</Button>
                </DialogActions>
            </Dialog>
        </Container >
    )
}

export default Titles